<template>
  <!-- 代表团详情 -->
  <div class="s-page">
    <div class="content">
        <div class="medal_total">
          <div>{{unitName}}</div>
          <img :src="goldMedal"/>{{details.goldMedal||0}} &nbsp;&nbsp;&nbsp;&nbsp;
          <img :src="silverMedal"/>{{details.silverMedal||0}} &nbsp;&nbsp;&nbsp;&nbsp;
          <img :src="bronzeMedal"/>{{details.bronzeMedal||0}}
        </div>
        <div class="types">
          <div class="tabs">
            <div class="tab_btn" :class="tabIndex == 0 ? 'active' : ''" @click="handleTab(0)">按比赛项目</div>
            <div class="tab_btn" :class="tabIndex == 1 ? 'active' : ''" @click="handleTab(1)">按奖牌类型</div>
          </div>
          <div class="tabs projects">
            <div class="program-name">{{tabIndex == 0?'项目':'奖牌'}}</div>
            <div class="center">
              <div class="btns-list" v-if="tabIndex == 0">
                  <div class="btns-item" :class="activeProjectIndex == index ? 'active' : ''"  v-for="(item, index) in newProjects" :key="index" @click="activeProjectId(item.id,index)">{{ item.name }}</div>
              </div>
              <div class="btns-list" v-if="tabIndex == 1">
                  <div class="btns-item" :class="activeProjectIndex == index ? 'active' : ''"  v-for="(item, index) in rankTypeList" :key="index" @click="changRank(item.id,index)">{{ item.name }}</div>
              </div>
              <div class="showMore" v-if="tabIndex == 0" @click="showMore">{{more?'收缩全部':'展开全部'}}</div>
            </div>
          </div>
        </div>
        <div class="details" v-if="programs.length > 0">
          <a-collapse v-model="activeKey">
            <a-collapse-panel v-for="(item, index) in programs" :key="index + ''">
              <span slot="header" class="header">{{item.name}}</span>
              <div slot="extra" class="medal_box">
                <div v-if="item.goldNum && item.goldNum != 0">
                  <img :src="goldMedal"/> {{ item.goldNum }}
                </div>
                <div v-if="item.silverNum && item.silverNum != 0">
                  <img :src="silverMedal"/> {{ item.silverNum }}
                </div>
                <div v-if="item.bronzeNum && item.bronzeNum != 0">
                  <img :src="bronzeMedal"/> {{ item.bronzeNum }}
                </div>
              </div>
              <div class="players">
                <div class="player_item" v-for="(player, pIndex) in item.playerList" :key="pIndex" :style="{marginRight:pIndex%6!==5?'14px':''}" @click="delegationPlayer(player,item,pIndex)">
                  <img class="head" :src="player.image"/>
                    <div class="name">{{ player.name }}</div>
                    <div class="tm">{{ player.combatName }}</div>
                    <template v-if="tabIndex ==1">
                      <img class="medal"  :src="player.ranking == 1 ? goldMedal : (player.ranking == 2 ? silverMedal : bronzeMedal)" />
                    </template>
                </div>
              </div>
            </a-collapse-panel>
          </a-collapse>
        </div>
      <div class="empty" v-else>
        <a-empty :image-style="{height: '60px',}" >
          <span slot="description"> 暂无数据 </span>
        </a-empty>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DelegationDetail',
  data () {
    return {
      goldMedal: require('@district/assets/icon/gold_medal.png'),
      silverMedal: require('@district/assets/icon/silver_medal.png'),
      bronzeMedal: require('@district/assets/icon/bronze_medal.png'),
      totalMedal: require('@district/assets/icon/total_medal.png'),
      down: require('@district/assets/icon/down.png'),
      tabIndex: 0,
      activeProjectIndex: 0,
      activeKey: ['0'],
      projects: [
        { id: -1, name: '全部' },
        { id: 1, name: '跆拳道' },
        { id: 2, name: '田径' },
        { id: 3, name: '游泳' },
        { id: 4, name: '足球' },
        { id: 5, name: '篮球' },
        { id: 6, name: '排球' },
        { id: 7, name: '射击' },
        { id: 8, name: '网球' },
        { id: 9, name: '乒乓球' },
        { id: 10, name: '羽毛球' },
        { id: 11, name: '空手道' },
        { id: 12, name: '兵道' },
        { id: 13, name: '自由搏击' },
        { id: 14, name: '艺术体操' },
        { id: 15, name: '武术' },
        { id: 16, name: '射箭' },
      ],
      details: [],
      programs:[],//参赛项目运动员列表
      seriesProgram:[],//项目列表
      more:true,
      item:{},
      agencyId:this.$route.query.agencyId?this.$route.query.agencyId:0,
      programId:-1,
      unitName:this.$route.query.unitName?decodeURIComponent(this.$route.query.unitName):'代表团',//代表团名称
      rankTypeList:[
        {id:-1, name: '全部'},
        {id:1,name:'金牌'},
        {id:2,name:'银牌'},
        {id:3,name:'铜牌'},
      ],
      detailParams:{
        agencyId:0,
        programId:-1,
        type:1,
        rankType:-1,
      }
    }
  },
  mounted (){
    this.showMore(1)
    this.detailParams.agencyId=this.agencyId
    this.getDelegationDetail()
    this.getSeriesProgram()
  },
  methods: {
    //比赛项目和类型
    handleTab (index){
      this.tabIndex=index
      this.detailParams.programId=-1
      this.detailParams.rankType=-1
      this.activeProjectIndex=0
      if(index==0){
        this.detailParams.type =1
      }else{
        this.detailParams.type =2
      }
      this.getDelegationDetail()
    },
    //选择奖牌
    changRank (rankType,index){
      this.activeProjectIndex=index
      this.detailParams.rankType=rankType
      this.getDelegationDetail()
    },
    //选择项目
    activeProjectId (programId,index){
      this.activeProjectIndex=index
      this.detailParams.programId=programId
      this.getDelegationDetail()
    },
    //查看运动员详情
    delegationPlayer (player,item,index){
      this.$router.push({
        name:'DelegationPlayer',
        query:{
          programName:encodeURIComponent(item.name),
          agencyId:this.agencyId,
          playerId:player.cardId,
          matchId:item.matchId,
        }
      })
    },
    showMore () {
      this.more=!this.more
    },
    //代表团数据列表
    async getDelegationDetail (){
      try {
        let res =await this.$api.district.delegationDetail(this.detailParams)
        if(res.status ==0){
          this.details=res.data
          this.programs=res.data.programs
        }else{
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.log(error)
      }
    },
    //所有比赛项目
    async getSeriesProgram (){
      try {
        let res =await this.$api.district.seriesProgram()
        if(res.status==0){
          res.data.unshift({name:'全部',id:-1})
          this.seriesProgram=res.data
        }else{
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
  computed:{
    newProjects (){
      let newseriesProgram=JSON.parse(JSON.stringify(this.seriesProgram))
      if(!this.more){
        return newseriesProgram.slice(0,12)
      }else{
        return newseriesProgram
      }
    }
  },
}
</script>
<style scoped lang="scss">
  .s-page{
    width: 100%;
    padding-bottom: 30px;
    min-height: 361px;
    .content {
      width: 1200px;
      margin: 0 auto;
      .medal_total {
        display: flex;
        justify-content: flex-start;
        height: 57px;
        line-height: 57px;
        align-items: center;
        font-size: 19px;
        font-weight: bold;
        div:first-child{
          margin-right: 20px;
        }

        img {
          height: 26px;
          width: 26px;
        }
      }
      .types {
        background: white;
        border: 1px solid #ffffff;
        border-radius: 10px;
        box-shadow: 0px 2px 6px 0px rgba(33,26,30,0.08);
        border-radius: 10px;
        padding: 30px 22px 30px 22px;
        .tabs {
          width: 100%;
          display: flex;
          font-size: 16px;
          align-items: center;
          flex-wrap: wrap;
          .tab_btn {
            min-width: 140px;
            height: 40px;
            font-size: 14px;
            line-height: 40px;
            background: #D2D2D2;
            text-align: center;
            color: white;
            cursor: pointer;
            margin-right: 10px;
          }
          .active {
            background-color: #009EDF;
          }
          .showMore{
            width: 80px;
            height: 40px;
            font-size: 16px;
            line-height: 40px;
            text-align: center;
            margin-bottom: 10px;
            color: #009EDF;
            cursor: pointer;
          }
        }
        .projects {
          width: 100%;
          margin-top: 20px;
          color: #333333;
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          .program-name{
            width: 80px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            position: relative;
          }
          .program-name::after{
            content:"";
            position: absolute;
            right: 10px;
            top: 10px;
            width: 2px ;
            height: 20px;
            background-color: #333333;
          }
          .center{
            display: flex;
            width: 1070px;
            .btns-list {
              width: 1000px;
              display: flex;
              align-items: center;
              flex-wrap: wrap;
              justify-content: flex-start;
              .btns-item{
                width: 80px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                cursor: pointer;
                margin-bottom: 10px;
              }
            }
            .active {
              background: #009EDF;
              color: #ffffff;
            }
          }
        }
      }
      .details {
        background: white;
        border-radius: 10px;
        box-shadow: 0px 2px 6px 0px rgba(33,26,30,0.08);
        border-radius: 10px;
        margin-top: 20px;
        padding-left: 10px;

        .header {
          font-size: 16px;
        }
        .medal_box {
          display: flex;
          div {
            margin-left: 20px;
            img {
              height: 26px;
              width: 26px;
            }
          }
        }
        .players {
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          align-items: center;
          margin-bottom: 20px;
          box-sizing: border-box;
          color: #333333;
          .player_item {
            background: #F1F1F1;
            border-radius: 10px 10px 0 0;
            cursor: pointer;
            display: flex;
            justify-content: flex-start;
            flex-direction: column;
            width: 180px;
            height: 260px;
            box-sizing: border-box;
            margin-bottom: 14px;
            align-items: center;
            position: relative;
            padding-top: 15px;
            .head {
              width: 155px;
              height: 155px;
            }
           
            .name {
              width: 180px;
              font-weight: 600;
              font-size: 16px;
              margin-top: 14px;
              padding: 0 10px;
            }
            .tm {
              width: 180px;
              font-size: 14px;
              overflow: hidden;//多出的隐藏
              text-overflow: ellipsis;//多出部分用...代替
              display: -webkit-box;//定义为盒子模型显示
              -webkit-line-clamp: 2;//用来限制在一个块元素显示的文本的行数
              -webkit-box-orient: vertical;//从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
              padding-left: 10px;
              padding-right: 30px;
            }
            .medal {
              width: 40px;
              height: 40px;
              position: absolute;
              right: -2px;
              bottom: -5px;
            }
            
          }
        }
      
      }
      .details>.detail_item:not(:last-child) {
        border-bottom: 1px solid #e4e4e4;
        margin-bottom: 10px;
      }
      .empty{
        width: 100%;
        min-height: 300px;
        padding-top: 90px;
        margin: 0 auto;
        color: #999;
      }
    }
    .ant-collapse /deep/ {
      border: 0px;
      background: white;
    }
    .ant-collapse-item /deep/ {
      border-bottom: 1px solid #e4e4e4;
      padding-top: 5px;
      padding-bottom: 5px;
    }
    .ant-collapse-item /deep/ .ant-collapse-content  {
      border-top: 0px
    }
  }
</style>



// WEBPACK FOOTER //
// src/district/views/delegation/components/DelegationDetail.vue